export const iconFontAwesomeShoppingCcJcb = (
	<i className="fa-solid fa-cc-jcb"></i>
);
